<template>
  <footer class="footer">
    <div class="j-container">
      <a class="footer-logo" @click="goToOfficalSite">
        <img src="@/assets/images/group-logo.svg" alt="Logo" />
      </a>
      <span class="copyright"
        >Copyright © 2010-{{ getCurrentYear }}, www.cnjauto.com.cn, All rights
        reserved
      </span>
      <FooterNav></FooterNav>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterNav from './FooterNav.vue';

export default defineComponent({
  name: 'Footer',
  components: {
    FooterNav
  },
  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    goToOfficalSite() {
      window.open('http://www.nanjunauto.com/');
    }
  }
});
</script>

<style scoped lang="scss">
.footer {
  padding: 34px 20px;
  background-color: #003399;
}

.j-container {
  display: flex;
  align-items: center;
}

.footer-logo {
  height: 32px;

  img {
    height: inherit;
  }
}

.copyright {
  white-space: nowrap;
  font-size: 14px;
  line-height: 1;
  color: #eeeeee;
  letter-spacing: 0.1px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-right: 40px;
  margin-right: auto;

  &::before {
    content: '';
    display: inline-block;
    width: 1px;
    height: 30px;
    border-right: 1px solid #d8d8d8;
    margin-left: 30px;
    margin-right: 30px;
  }
}
</style>
